import posthog from 'posthog-js'
import * as Sentry from '@sentry/react'
import type { User } from './types'

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined

export function initAnalytics(): void {
  if (POSTHOG_KEY) {
    posthog.init(POSTHOG_KEY, {
      api_host: 'https://us.i.posthog.com',
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: true,
      persistence: 'localStorage',
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-ph-mask]',
      },
    })
  }

  if (SENTRY_DSN) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: import.meta.env.MODE,
      release: (import.meta.env.VITE_GIT_SHA as string) || 'local',
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.1,
    })
  }
}

export function identifyUser(user: User): void {
  if (POSTHOG_KEY) {
    posthog.identify(String(user.id), {
      email: user.email,
      is_staff: user.is_staff,
    })
  }
  if (SENTRY_DSN) {
    Sentry.setUser({ id: String(user.id), email: user.email })
  }
}

export function resetAnalytics(): void {
  if (POSTHOG_KEY) posthog.reset()
  if (SENTRY_DSN) Sentry.setUser(null)
}

export function track(event: string, properties?: Record<string, unknown>): void {
  if (POSTHOG_KEY) posthog.capture(event, properties)
}

export function trackPageView(path: string): void {
  if (POSTHOG_KEY) posthog.capture('$pageview', { $current_url: path })
}
